export enum ContractsSortBy {
  ContractName = 'contractName',
  CreatedBy = 'createdBy',
  CreatedDate = 'createdDate',
}
